<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :bordered=false>
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
        <span class="page-status " :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
      </div>
      <div slot="extra" style="cursor:pointer" class="extra" v-if="pageLayout.functions">
        <span v-for="(item,index) in pageLayout.functions" :key="index" style="margin-left:17px;">
          <span class="extra-trigger" @click="print" v-if="item.action==='print'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcFile'" />打印
          </span>
        </span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && loadedLayout">
        <common-form v-if="layout.type==='commonForm'" :ref="'commonForm'" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :default-params="defaultParams" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo" :from-detail="true"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="loadedInfo && loadedLayout"></approval-flow>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-row class="footer">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="20">
          <a-button @click="visibleComment = true" style="width:120px;" v-if="loadedInfo && loadedLayout">评论</a-button>
        </a-col>
      </a-row>
    </a-card>
    <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import SvgIcAll from "../../assets/svg/ic-all-o.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import FormModal from "../../components/FormModal.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  reimburseBaseLayout,
  getReimburseDetailInfo,
  reimburseCreateInfo,
  submitReimburse,
  getReimburseDetailApprovalFlow,
  printUrl
} from "../../services/CommonService.js";

import {
  backInfoFormModal,
  agreeInfoFormModal
} from "../../data/formModalConfigs.js";

export default {
  components: {
    SvgIcAll,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    Upload,
    FormModal
  },
  data() {
    return {
      introductionVisible: false,
      retreatModalVisible: false,
      canEdit: false,
      breadcrumb: [
        {
          label: "发起申请",
          path: {
            name: "launchApplication"
          }
        },
        {
          label: "待我审批详情",
          path: ""
        }
      ],
      params: {},
      defaultParams: {}, // 复制时需要用到创建用到的默认参数
      loadedLayout: false,
      loadedInfo: false,
      canSubmit: true,
      pageLayout: {},
      approvalFlowInfo: [],
      summationInfo: {},
      requestParams: {},
      cancelSource: null,
      visibleComment: false
    };
  },

  created() {
    this.fromLocation =
      window.location.href.indexOf("fromLocation=msg") === -1 ? "app" : "msg";
    this.id = this.$route.query.id;
    this.fetchApprovalFlow();
    Promise.all([this.getReimburseDetailInfo(this.id)]).then(() => {
      this.fetchPageLayout();
    });
  },

  methods: {
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      this.requestParams = _.cloneDeep(this.params);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
    },
    // 获取整个页面表单布局
    fetchPageLayout() {
      this.loadedLayout = false;
      reimburseBaseLayout({
        id: this.$route.query.id,
        show_type: "detail",
        menu_type: 3,
        ding_msg_switch: this.fromLocation === "msg" ? 1 : 0
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loadedLayout = true;
        } else {
          this.$Message.error(res.message);
          this.loadedLayout = true;
        }
      });
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      getReimburseDetailApprovalFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 获取详情信息
    getReimburseDetailInfo(id) {
      return getReimburseDetailInfo(id, { menu_type: 3 }).then(res => {
        if (res.status === "success") {
          this.params = Object.assign({}, this.params, res.data);
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    back() {
      this.$router.replace({
        name: "approvedByMeList"
      });
    },

    print() {
      const accessToken = localStorage.getItem("accessToken");
      location.href = `${window.location.origin}/api/oa/reimburse/pdf/${
        this.$route.query.id
      }?accessToken=${accessToken}`;
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
.create-application-box {
  padding: 16px;
}
.introductionModal {
  .ant-modal-footer {
    .ant-btn-default {
      display: none;
    }
  }
}
</style>
